import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NO_VALUE } from '@pipes';
import moment from 'moment';

@Pipe({
  name: 'dateDiffMonths',
})
export class DateDiffMonthsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(date: Date | string): string {
    if (!date) {
      return NO_VALUE;
    }

    const momentDate = moment(date);

    const monthsCounter = Math.round(momentDate.diff(moment(), 'months', true));
    if (monthsCounter < -1) {
      return this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.TIME.MONTHS_AGO',
        { count: Math.abs(monthsCounter) }
      );
    }
    if (monthsCounter === -1) {
      return this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.TIME.ONE_MONTH_AGO'
      );
    }
    if (monthsCounter === 0) {
      return this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.TIME.THIS_MONTH'
      );
    }
    if (monthsCounter === 1) {
      return this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.TIME.ONE_MONTH'
      );
    }
    if (monthsCounter > 1) {
      return this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.TIME.IN_MONTHS',
        { count: monthsCounter }
      );
    }
  }
}
